import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { isColabApiErrorShape } from '../utils/api';

const MAX_RETRY_ATTEMPTS = 1;
const RETRY_ATTEMPT_TOKEN = new HttpContextToken<number>(() => 0);

export function refreshTokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const errResponse = error.error;
      const isAddSessionPath = req.url.endsWith('/api/user/session/add');

      if (isColabApiErrorShape(errResponse) && error.status === 401 && !isAddSessionPath) {
        const currentAttempts = req.context.get(RETRY_ATTEMPT_TOKEN);

        if (currentAttempts >= MAX_RETRY_ATTEMPTS) {
          router.navigate(['/no-access']);
          return throwError(() => error);
        }
        authService.cleanupSession();

        return from(authService.refreshCoLabSession()).pipe(
          switchMap(() => {
            const newToken = authService.sessionToken();

            if (newToken) {
              const retryReq = req.clone({
                headers: req.headers.set('sessionToken', newToken),
                context: req.context.set(RETRY_ATTEMPT_TOKEN, currentAttempts + 1)
              });
              return next(retryReq);
            } else {
              return throwError(() => error);
            }
          })
        );
      }
      return throwError(() => error);
    })
  );
}
